<ul class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs; let index = index">
    <a [routerLink]="breadcrumb.url" [id]="breadcrumb.label">
      <span class="sr-only" *ngIf="!index">{{ 'navigation.information-hors-ecran' | translate }}&nbsp;</span>
      {{ breadcrumb.label | translate }}
    </a>
  </li>
</ul>
